import type { ReactNode } from 'react';
import { Flex, type FlexProps, Icon, IconButton } from '@/ui';
import { ZoomSlider } from '../ZoomSlider';
import { Pagination } from './Pagination';

type Props = FlexProps & {
  colorScheme?: string;
  zoomEnabled: boolean;
  scale: number;
  numPages: number;
  currentPage: number;
  isDisabled: boolean;
  cta?: ReactNode;
  hasDownload?: boolean;
  downloadUrl?: string;
  onNext: () => void;
  onPrev: () => void;
  onScaleChange: (value: number) => void;
};

export const PdfControls = ({
  colorScheme,
  zoomEnabled,
  scale,
  numPages,
  currentPage,
  isDisabled,
  cta,
  hasDownload,
  downloadUrl,
  onNext,
  onPrev,
  onScaleChange,
  ...props
}: Props) => {
  return (
    <Flex align="center" gap="2" justify="space-between" {...props}>
      <Flex align="center" gap="6">
        {numPages > 1 && (
          <Pagination
            currentPage={currentPage}
            isDisabled={isDisabled}
            numPages={numPages}
            onNext={onNext}
            onPrev={onPrev}
          />
        )}
        {zoomEnabled && (
          <ZoomSlider
            colorScheme={colorScheme}
            isDisabled={isDisabled}
            scale={scale}
            onScaleChange={onScaleChange}
          />
        )}
      </Flex>
      <Flex align="center" gap="2">
        {hasDownload && downloadUrl && (
          <IconButton
            aria-label="Open PDF"
            as="a"
            colorScheme={colorScheme}
            href={downloadUrl}
            icon={<Icon icon="ArrowUpRight" />}
            rel="noopener noreferrer"
            size="sm"
            target="_blank"
            variant="outline"
          />
        )}
        {cta}
      </Flex>
    </Flex>
  );
};
